import dynamic from 'next/dynamic'

export const SectionOfInvestors = dynamic(
    () => import('./section-of-investors'),
)
